const brandModalRouter = (beforeEnter, name, nested, edit) => {
    let param = {
        beforeEnter: beforeEnter,
        name: name,
        path: '/' + nested + '/' + ((edit) ? 'detalhe/:id' : 'cadastrar'),
        meta: {
            requiresAuth: true,
            isEmployee: edit,
            showModal: true,
            layout: 'default'
        },
        props: true,
        components: {
            brandModal: () => import('@/views/brand/FormBrand.vue')
        }
    }
    return param
}

export default brandModalRouter
